/** Column section titles (Our Products, Know Us, Download, Connect). */
export const footerColumnTitleSx = {
  fontSize: '1rem',
  fontWeight: 400,
  marginBottom: '10px',
  lineHeight: 1.35,
  textAlign: 'start',
  textDecoration: 'underline',
  fontFamily: 'Foregen',
};

/** @deprecated Use footerColumnTitleSx */
export const footerSectionHeadingSx = footerColumnTitleSx;
